module.exports = __webpack_public_path__ + "static/media/recoleta-semibold.c3234d36.woff2";